import { render, staticRenderFns } from "./trifle-handling.vue?vue&type=template&id=7600fdae&scoped=true&"
import script from "./trifle-handling.vue?vue&type=script&lang=js&"
export * from "./trifle-handling.vue?vue&type=script&lang=js&"
import style0 from "./trifle-handling.vue?vue&type=style&index=0&lang=css&"
import style1 from "./trifle-handling.vue?vue&type=style&index=1&id=7600fdae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7600fdae",
  null
  
)

export default component.exports